import { useMemo } from 'react';
import { useGetStudyReportsQuery } from '@/state/slices/reports';
import type { AIViewPrediction } from '@/models/aiScan';

/** The dicom's AI view prediction, read from the report payload the page
 *  already subscribes to (`aiViewPredictions`, flattened server-side with one
 *  prediction per dicom) — the reader makes no separate ai-scans call. */
export function useViewPrediction(
  studyUuid: string | undefined,
  dicomUuid: string | undefined
): AIViewPrediction | null {
  const { data: reportsPagination } = useGetStudyReportsQuery(studyUuid || '', {
    skip: !studyUuid,
  });

  return useMemo(() => {
    const predictions = reportsPagination?.results?.[0]?.aiViewPredictions;
    if (!dicomUuid || !predictions) return null;
    return predictions.find((p) => p.dicomUuid === dicomUuid) ?? null;
  }, [reportsPagination, dicomUuid]);
}
